import { Add, Edit } from "@mui/icons-material";
import { Box, Collapse, Typography } from "@mui/material";
import React, { useState } from "react";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import {
  getGroupsUsers,
  removeAreaFromTrip,
  updateArea,
} from "../../api/group";
import { storeArea } from "../../api/trip";
import DownArrow from "../../assets/SVG/downArrow";
import TrashIcon from "../../assets/SVG/trashIcon";
import AutoComplate from "../autocomplete/autoComplate";
import ColorInput from "../colorInput";
import CustomizedHook from "../project/autocomplatePro";
import { InputCreateProject } from "../project/createProjectPop";
import ButtonNextLevel from "../signin/buttonNextLevel";

export default function LevelTwoPop({
  trip,
  setTrip,
  regionName,
  setRegionName,
  colorData,
  setColorData,
  dataSelected,
  handleClose,
  level,
  setLevel,
  dataDef,
  countTrip,
  setCountTrip,
}) {
  const navigate = useNavigate();

  const [open, setOpen] = useState(1);
  const [options, setOptions] = useState();
  const [tripAdd, setTripAdd] = useState([]);
  const [areaManager, setAreaManager] = useState();

  const arrNumber = [
    "یک",
    "دو",
    "سه",
    "چهار",
    "پنج",
    "شش",
    "هفت",
    "هشت",
    "نه",
    "ده",
    "یازده",
  ];
  const color = [
    { color: "var(--emr-black)", name: "سیاه", enum: "BLACK" },
    { color: "var(--emr-green)", name: "سبز", enum: "GREEN" },
    { color: "var(--emr-blue)", name: "آبی", enum: "BLUE" },
    { color: "var(--emr-purple)", name: "بنفش", enum: "PURPLE" },
    { color: "var(--emr-yellow)", name: "زرد", enum: "YELLOW" },
    { color: "var(--emr-red)", name: "قرمز", enum: "RED" },
    { color: "var(--emr-lightblue)", name: "آبی کم رنگ", enum: "lightblue" },
  ];

  useEffect(() => {
    getGroupsUsers()
      .then((x) => setOptions(x))
      .catch(() => {});
  }, []);

  useEffect(() => {
    if (dataDef) {
      const formattedArray = dataDef.areas?.map((area) => ({
        name: area.name,
        owner: area.ownerId,
        areaId: area.id,
        color: area.color.toUpperCase(),
      }));
      setTrip(formattedArray);
    }
  }, [dataDef]);

  // تابع برای نمایش عنوان منطقه به صورت پیوسته
  const getRegionTitle = (index, isNewItem = false) => {
    const baseIndex = dataDef ? trip.length : 0;
    const totalIndex = isNewItem ? baseIndex + index : index;
    return `منطقه ${arrNumber[totalIndex]}`;
  };

  return (
    <Box height={"300px"}>
      <Box sx={{ height: "200px", overflow: "hidden auto " }}>
        {/* نمایش مناطق موجود */}
        {trip?.map((x, i) => (
          <React.Fragment key={`existing-${i}`}>
            <Box
              sx={{
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                mt: "10px",
              }}
              onClick={() => setOpen(i + 1)}
            >
              <Typography color="var(--emr-darkblue)" fontWeight="bold">
                {getRegionTitle(i)}
              </Typography>
              <DownArrow transform={open === i + 1 ? "rotate(90deg)" : ""} />
            </Box>
            <Collapse
              in={open === i + 1 ? true : false}
              timeout="auto"
              unmountOnExit
            >
              <Box
                mt="20px"
                gap="10px"
                display="flex"
                flexWrap={"wrap"}
                alignItems="center"
              >
                <InputCreateProject
                  mr="10px"
                  placeholder={"نام منطقه را وارد کنید."}
                  label="نام منطقه"
                  value={trip[i]?.name}
                  onChange={(event) => {
                    setTrip((z) => {
                      let array = [...z];
                      array[i].name = event.target.value;
                      return array;
                    });
                  }}
                />
                {trip?.length > 0 && (
                  <Box width="200px">
                    <CustomizedHook
                      multiple
                      placeholder={"انتخاب کنید."}
                      label="مسئول منطقه"
                      options={options}
                      onChange={(event, newValue) => {
                        setTrip((z) => {
                          let array = [...z];
                          array[i].owner = newValue.id;
                          return array;
                        });
                      }}
                      value={
                        options?.find((x) => x.id === trip[i]?.owner) || null
                      }
                    />
                  </Box>
                )}
                <ColorInput
                  width={"220px"}
                  color={color}
                  Color={colorData}
                  setColor={setColorData}
                  onChange={(event) => {
                    setTrip((z) => {
                      let array = [...z];
                      array[i].color = event.enum;
                      return array;
                    });
                  }}
                />
                {dataDef && (
                  <Box display="flex" mt="20px" gap="30px" pr="30px">
                    <Box
                      display="flex"
                      onClick={() => {
                        updateArea(dataDef.id, [x])
                          .then(() => {
                            toast.success("آپدیت شد");
                          })
                          .catch(() => {});
                      }}
                    >
                      <Typography>{"ثبت ویرایش"}</Typography>
                      <Edit
                        sx={{ transform: "scale(0.8)", cursor: "pointer" }}
                      />
                    </Box>
                    <Box
                      sx={{ cursor: "pointer" }}
                      onClick={() => {
                        if (dataDef) {
                          removeAreaFromTrip(dataDef.id, x.areaId)
                            .then(() => {
                              setTrip((z) => {
                                let array = [...z];
                                let result = array.filter(
                                  (y) => y.areaId !== x.areaId
                                );
                                return result;
                              });
                            })
                            .catch(() => {});
                        } else {
                          setTrip((z) => {
                            let array = [...z];
                            let result = array.filter(
                              (y) => y.areaId !== x.areaId
                            );
                            return result;
                          });
                        }
                      }}
                    >
                      <TrashIcon sx={{ cursor: "pointer" }} />
                    </Box>
                  </Box>
                )}
              </Box>
            </Collapse>
          </React.Fragment>
        ))}

        {/* نمایش مناطق جدید */}
        {tripAdd?.map((q, index) => (
          <React.Fragment key={`new-${index}`}>
            <Box
              sx={{
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                mt: "10px",
              }}
              onClick={() => setOpen(trip.length + index + 1)}
            >
              <Typography color="var(--emr-darkblue)" fontWeight="bold">
                {getRegionTitle(index, true)}
              </Typography>
              <DownArrow
                transform={
                  open === trip.length + index + 1 ? "rotate(90deg)" : ""
                }
              />
            </Box>
            <Collapse
              in={open === trip.length + index + 1 ? true : false}
              timeout="auto"
              unmountOnExit
            >
              <Box
                mt="20px"
                gap="10px"
                display="flex"
                flexWrap={"wrap"}
                alignItems="center"
              >
                <InputCreateProject
                  mr="10px"
                  placeholder={"نام منطقه را وارد کنید."}
                  label="نام منطقه"
                  value={tripAdd[index]?.name}
                  onChange={(event) => {
                    setTripAdd((b) => {
                      let array = [...b];
                      array[index].name = event.target.value;
                      return array;
                    });
                  }}
                />
                {tripAdd?.length > 0 && (
                  <Box width="200px">
                    <CustomizedHook
                      multiple
                      placeholder={"انتخاب کنید."}
                      label="مسئول منطقه"
                      options={options}
                      onChange={(event, newValue) => {
                        setTripAdd((z) => {
                          let array = [...z];
                          array[index].owner = newValue.id;
                          return array;
                        });
                      }}
                      value={
                        options?.find((q) => q.id === tripAdd[index]?.owner) ||
                        null
                      }
                    />
                  </Box>
                )}
                <ColorInput
                  width={"220px"}
                  color={color}
                  Color={colorData}
                  setColor={setColorData}
                  onChange={(event) => {
                    setTripAdd((z) => {
                      let array = [...z];
                      array[index].color = event.enum;
                      return array;
                    });
                  }}
                />
                <Box display="flex" mt="20px" gap="30px" pr="30px">
                  <Box
                    sx={{ cursor: "pointer" }}
                    onClick={() => {
                      setTripAdd((z) => {
                        let array = [...z];
                        let result = array.filter((_, i) => i !== index);
                        return result;
                      });
                    }}
                  >
                    <TrashIcon sx={{ cursor: "pointer" }} />
                  </Box>
                </Box>
              </Box>
            </Collapse>
          </React.Fragment>
        ))}
      </Box>

      {/* دکمه افزودن منطقه جدید */}
      {dataDef && (
        <Box
          onClick={() => {
            setTripAdd([
              ...tripAdd,
              {
                name: "",
                owner: "",
                color: "BLACK",
              },
            ]);
          }}
          sx={{
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            mt: 2,
          }}
        >
          <Add sx={{ mr: 1 }} />
          <Typography>افزودن منطقه جدید</Typography>
        </Box>
      )}

      <Box display="flex" mt="-20px" justifyContent={"end"}>
        <ButtonNextLevel
          setLevel={setLevel}
          level={level}
          onClickNextLevel={() => {
            if (dataDef) {
              storeArea(dataDef.id, tripAdd)
                .then(() => {
                  navigate("/trips");
                  handleClose();
                })
                .catch(() => {});
            } else {
              storeArea(dataSelected, trip)
                .then(() => {
                  navigate("/trips");
                })
                .catch(() => {});
            }
          }}
        />
      </Box>
    </Box>
  );
}
